module.exports = __webpack_public_path__ + "static/media/printing-services-img6.40f4fd5b.jpg";